import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateVehicleSetupActions as Actions,
  CreateVehicleSetupRequestAction as RequestAction,
} from 'store/ducks/vehicleSetups';

export function* createVehicleSetupRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `vehicle-setups`, postData);
    onSuccess && onSuccess();
    notify('success', 'Configuração de veículo criada com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
